import _ from 'lodash'

export function normalizeWorkflowDate(value) {
  if (!value) {
    return null
  }
  if (value instanceof Date) {
    return value
  }
  if (_.isNumber(value)) {
    return new Date(Number(value))
  }
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) {
    return null
  }
  return date
}

export function sortWorkflowsAsc(workflows = []) {
  return _.cloneDeep(workflows)
    .sort((a, b) => parseFloat(_.get(a, 'ordem', 0)) - parseFloat(_.get(b, 'ordem', 0)))
    .map((workflow, index) => ({
      ...workflow,
      ordem: index + 1,
    }))
}

export function sortTramitesDesc(tramites = []) {
  return _.cloneDeep(tramites).sort((a, b) => {
    const dataA = normalizeWorkflowDate(_.get(a, 'dataTramite', null))
    const dataB = normalizeWorkflowDate(_.get(b, 'dataTramite', null))
    const timeA = dataA ? dataA.getTime() : 0
    const timeB = dataB ? dataB.getTime() : 0
    if (timeA !== timeB) {
      return timeB - timeA
    }
    return Number(_.get(b, 'oid', 0)) - Number(_.get(a, 'oid', 0))
  })
}

export function addHoursToDate(date, horas) {
  const dataBase = normalizeWorkflowDate(date)
  if (!dataBase) {
    return null
  }
  const totalHoras = Number(horas)
  if (Number.isNaN(totalHoras)) {
    return null
  }
  const totalMinutos = Math.round(totalHoras * 60)
  return new Date(dataBase.getTime() + totalMinutos * 60000)
}

export function applyWorkflowRules({
  workflows = [],
  loggedUser = null,
  setFirstStartDate = false,
  now = new Date(),
}) {
  const workflowsOrdenados = sortWorkflowsAsc(workflows)
  let statusContrato = null

  workflowsOrdenados.forEach((workflow, index) => {
    const workflowAnterior = index > 0 ? workflowsOrdenados[index - 1] : null
    const dataTerminoAnterior = normalizeWorkflowDate(_.get(workflowAnterior, 'dataTermino', null))

    if (index === 0) {
      if (setFirstStartDate && !normalizeWorkflowDate(workflow.dataInicio)) {
        workflow.dataInicio = now
      }
    } else if (dataTerminoAnterior) {
      workflow.dataInicio = dataTerminoAnterior
    } else {
      workflow.dataInicio = null
    }

    const dataInicio = normalizeWorkflowDate(workflow.dataInicio)
    const dataTermino = normalizeWorkflowDate(workflow.dataTermino)

    workflow.finalizado = !!dataTermino
    workflow.sla = Boolean(workflow.sla)
    workflow.dataLimite = dataInicio ? addHoursToDate(dataInicio, workflow.tempoSlaHoras) : null
    workflow.tramites = sortTramitesDesc(workflow.tramites)

    if (!_.get(workflow, 'usuario.id', null) && loggedUser) {
      workflow.usuario = loggedUser
    }

    if (dataTermino && _.get(workflow, 'statusContrato.id', null)) {
      statusContrato = _.get(workflow, 'statusContrato', null)
    }
  })

  return { workflows: workflowsOrdenados, statusContrato }
}

export function instantiateWorkflowFromTipoSepultura({ tipoSepultura, loggedUser = null, now = new Date() }) {
  const templates = sortWorkflowsAsc(_.get(tipoSepultura, 'workflows', []))
  const workflows = templates.map((template) => ({
    oid: '',
    oidWorkflow: _.get(template, 'oid', null),
    workflow: _.get(template, 'nome', ''),
    ordem: _.get(template, 'ordem', null),
    descricao: _.get(template, 'nome', ''),
    dataInicio: null,
    dataTermino: null,
    dataLimite: null,
    finalizado: false,
    sla: false,
    statusContrato: _.get(template, 'statusContrato', null),
    tempoSlaHoras: _.get(template, 'tempoSlaHoras', null),
    usuario: loggedUser,
    tramites: [],
  }))

  return applyWorkflowRules({
    workflows,
    loggedUser,
    setFirstStartDate: true,
    now,
  })
}
